var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card pa-4 red-border bottom-line"},[_vm._v(" I am a log on of something. Add property, made property vacant, occupied. ")])}
var staticRenderFns = []

export { render, staticRenderFns }